export let ManagementLevel;

(function (ManagementLevel) {
  ManagementLevel["Owner"] = "owner";
  ManagementLevel["ExecutiveTeam"] = "executive-team";
  ManagementLevel["Manager"] = "manager";
  ManagementLevel["Employee"] = "employee";
  ManagementLevel["StudentIntern"] = "student-intern";
  ManagementLevel["Freelancer"] = "freelancer";
  ManagementLevel["Other"] = "other";
})(ManagementLevel || (ManagementLevel = {}));

export const ManagementLevelOptions = Object.values(ManagementLevel).filter(option => option !== ManagementLevel.Other);